/**
 * The last full read of each workbench view, kept across mounts.
 *
 * The workbench's tabs unmount the views they hide, so opening a view again
 * used to download everything it shows. With this, a view opened again shows
 * what it had at once and asks the server, with that read's ETag, whether
 * anything changed: usually a 304. Module-level (no query library), bounded,
 * and cleared between tests (`vitest.setup.mjs`).
 */

export interface CachedRead {
  data: unknown;
  etag: string | null;
}

/** Enough for every view of a few cases. */
const MAX_ENTRIES = 40;

const reads = new Map<string, CachedRead>();

export function readCached(key: string): CachedRead | undefined {
  return reads.get(key);
}

export function writeCached(key: string, entry: CachedRead): void {
  // Map order is insertion order: re-inserting keeps the newest last, so
  // the first key is the one least recently written.
  reads.delete(key);
  reads.set(key, entry);
  while (reads.size > MAX_ENTRIES) {
    const oldest = reads.keys().next().value;
    if (oldest === undefined) {
      break;
    }
    reads.delete(oldest);
  }
}

export function clearWorkbenchReadCache(): void {
  reads.clear();
}
